export default {
  PLANS_SELECTION: 1,
  PAYMENT_METHODS: 2,
}